module.exports = __webpack_public_path__ + "static/media/sell_help_6.e2f3d4fb.png";